import { render, staticRenderFns } from "./KpiDashboard.vue?vue&type=template&id=f39d07f0&scoped=true"
import script from "./KpiDashboard.vue?vue&type=script&lang=js"
export * from "./KpiDashboard.vue?vue&type=script&lang=js"
import style0 from "./KpiDashboard.vue?vue&type=style&index=0&id=f39d07f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f39d07f0",
  null
  
)

export default component.exports